import { Component, OnInit } from '@angular/core';
import { ContractService } from '../../_services';
import { IContract, IChangeCallback } from '../../_entities';
import { ContractBase } from "./contract.base";

@Component({
    selector: 'contract-extension',
    template: require('./contract-extension.template.html')
})
export class ContractExtensionComponent extends ContractBase implements OnInit {

    private defaultNumbers: string[] = Array(8).fill(null);

    constructor(
        protected readonly contractService: ContractService) {
        super(contractService);
    }

    onYearPeriodsChange(event: IChangeCallback<any>) {

    }

    get extension(): any {
        const contract: any = this.contract;
        return contract != null ? contract.extension : null;
    }

    private pValues: string[];

    get yearPeriodValues(): string[] {
        if (this.pValues != null) {
            return this.pValues;
        }
        if (this.extension == null) {
            return this.defaultNumbers;
        }
        if (this.extension.yearPeriods != null && this.extension.yearPeriods.length > 0) {
            this.pValues = this.extension.yearPeriods.split(";");
        } else {
            this.pValues = this.defaultNumbers;
        }
        return this.pValues;

    }

    onYearPeriodChange(idx: number, contract: IContract, event: IChangeCallback<any>): void {
        if (event.newValue == null || event.newValue === "") {
            event.newValue = null;
        }
        else {
            const value = parseInt(event.newValue);
            if (isNaN(value)) {
                event.reject("Period must be a number");
                return;
            }
        }
        this.yearPeriodValues[idx] = event.newValue;

        const patches = [
            { "op": "replace", "path": `/extension.yearPeriods`, "value": this.yearPeriodValues.join(";") }
        ];
        this.contractService.patchItem(contract.id, patches, event.oldValue).then((updatedContract) => {
            event.resolve();
            contract = updatedContract;
        }).catch((err) => {
            event.reject(err);
        });
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
    }


}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/contract/contract-extension.component.ts